import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Paper,
  Chip,
  Divider,
} from "@mui/material";
import { Assignment as AssignmentIcon } from "@mui/icons-material";

const AssignedOrdersDialog = ({ open, onClose, orders = [] }) => {
  const title = `Assigned Order${orders.length !== 1 ? "s" : ""}`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          minHeight: 350,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          overflow: "hidden",
        },
      }}
    >
      {/* Header Section */}
      <DialogTitle
        sx={{
          background: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          position: "relative",
          padding: 3,
          paddingBottom: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h5"
              component="div"
              sx={{
                fontWeight: 600,
                color: "#2d3748",
                mb: 1,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#435674ff",
                fontWeight: 500,
              }}
            >
              Total order{orders.length !== 1 ? "s" : ""}:{" "}
              <strong style={{ color: "#000000ff", fontSize: "1rem" }}>
                {orders.length}
              </strong>{" "}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{ padding: 0, background: "rgba(255, 255, 255, 0.95)" }}
      >
        <Box sx={{ p: "8px 24px" }}>
          {orders.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 6,
                color: "#718096",
              }}
            >
              <AssignmentIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
                No Orders Assigned
              </Typography>
              <Typography variant="body2">
                There are currently no orders assigned to display.
              </Typography>
            </Box>
          ) : (
            <Paper
              sx={{
                maxHeight: 350,
                overflowY: "auto",
                p: 3,
                background: "linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)",
                border: "1px solid rgba(102, 126, 234, 0.2)",
                borderRadius: 2,
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(0,0,0,0.1)",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  borderRadius: "4px",
                  "&:hover": {
                    background: "linear-gradient(135deg, #5a67d8, #6b46c1)",
                  },
                },
              }}
              elevation={0}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 1,
                  color: "#4a5568",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  fontSize: "0.75rem",
                }}
              >
                {`Job Number${orders.length > 1 ? "s" : ""}`}
              </Typography>
              <Divider sx={{ mb: 2, background: "rgba(102, 126, 234, 0.2)" }} />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1.5,
                  alignItems: "flex-start",
                }}
              >
                {orders.map((order, index) => (
                  <Chip
                    key={order}
                    label={order}
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.875rem",
                      height: 36,
                      px: 1,
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                      },
                    }}
                  />
                ))}
              </Box>
            </Paper>
          )}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: 3,
          background: "rgba(255, 255, 255, 0.95)",
          borderTop: "1px solid rgba(255, 255, 255, 0.2)",
          justifyContent: "flex-end",
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            fontWeight: 600,
            px: 2,
            py: 1,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "1rem",
            transition: "all 0.2s ease-in-out",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignedOrdersDialog;
